import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';

import { PropTypes } from 'prop-types';

if (process.env.GA) {
  GoogleAnalytics.initialize(process.env.GA);

  if (process.env.VERSION) {
    GoogleAnalytics.set({ release: process.env.VERSION });
  }
}

const fakeWithTracker = (WrappedComponent, options = {}) => WrappedComponent;

const withTracker = (WrappedComponent, options = {}) => {
  const trackPage = (page) => {
    GoogleAnalytics.set({
      page,
      ...options,
    });
    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

  return HOC;
};

export default process.env.GA ? withTracker : fakeWithTracker;



// WEBPACK FOOTER //
// ./src/app/utils/withTracker.js